$mol_view_tree2_to_js_test_ex_array_number_foo $mol_object
	bar /
		-NaN
		-Infinity
		+Infinity
		0
